/** @file checkFrame: FRAME_OUT_OF_RANGE unless a key frame lies in 0..frames (keys may sit on frames). */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** Throws `FRAME_OUT_OF_RANGE` at `path` when `frame` is above `clip.frames` or below 0. */
export function checkFrame(clip: Pick<Clip, 'frames'>, frame: number, path: string): void {
  if (frame < 0 || frame > clip.frames) {
    throwError(ERROR_CODES.FRAME_OUT_OF_RANGE, { frame, last: clip.frames }, { path, hint: `key frames are 0..${clip.frames}; clip.setMeta frames to lengthen the clip` });
  }
}
